import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import TextLoader from '../../../components/global/Loader/text';
import Doctor from '../Appointments/doctor';
import DoctorSkeleton from './doctorSkeleton';

export default function CurrentAppointmentsV2({
  section,
  cancelAppointment,
  goToPastAppointments,
  isVisible,
  city,
}) {
  const history = useHistory();
  const { skeleton, detailsMap, loadingProviders, loading } = section;

  if (!isVisible) return null;

  if (!skeleton || (loading && !skeleton.length)) return <TextLoader />;

  const onClickButton = (e) => {
    e.preventDefault();
    history.push('/');
  };

  return (
    <div className="streaming-records-current">
      <div className="streaming-records-title streaming-records-title--with-action">
        <div className="streaming-records-title-records-wrapper">
          <button
            type="button"
            className="streaming-records-title-records-item active"
            aria-current="page"
          >
            <i className="fas fa-calendar-alt" />
            Майбутні записи
          </button>
          <button
            type="button"
            className="streaming-records-title-records-item"
            onClick={goToPastAppointments}
          >
            <i className="fas fa-history" />
            Минулі записи
          </button>
        </div>
          <Button className="streaming-records-title-book-btn" onClick={onClickButton}>
            Записатись на прийом
          </Button>
      </div>

      {skeleton && skeleton.length ? (
        skeleton.map((item) => {
          const full = detailsMap[item.id];
          if (full) {
            return (
              <Doctor
                key={item.id}
                city={city}
                cancelAppointment={cancelAppointment}
                {...full}
              />
            );
          }
          return (
            <DoctorSkeleton
              key={item.id}
              {...item}
              isLoading={loadingProviders.has(item.provider_id)}
            />
          );
        })
      ) : (
        <div className="cabinet-no-records">
          <div className="cabinet-no-records-title">Записи на прийом відсутні</div>
          <Button className="cabinet-no-records-btn" onClick={onClickButton}>
            Записатись на прийом
          </Button>
        </div>
      )}
    </div>
  );
}
